<div class="question">
  <div class="question-pull">

    <div class="reference-pill mb-30">
      <dl>
        <dt>Quote reference number</dt>
        <dd>{{ pageInfo?.quote_id }}</dd>
      </dl>
    </div>

    @for (uwItem of productSelected?.uw_collation?.items; track uwItem) {
      <div class="uw-list">
        <div class="uw-list__class">
          <img [src]="uwItem.img_path" class="icon icon--lg" alt="" />
          <small class="font-uppercase"><strong>{{ uwItem.class_name }}</strong></small>
        </div>
        <ul class="uw-list__list">
          <li class="uw-list__item" (click)="openSidesheet(uwItem)">
            <div class="uw-list__item-title">
              <span class="tag-pill tag-pill--info-number-bg">{{ uwItem.uw_count }}</span>
              <p class="font-16">{{ uwItem.description_2 }}</p>
            </div>
            <div class="uw-list__item-caret">
              <svg class="icon">
                <use xlink:href="#chevron-right"></use>
              </svg>
            </div>
          </li>
        </ul>
      </div>
    }

  </div>
</div>
<app-sidesheet
  #uwSidesheet
  sidesheetId="uw-item-sidesheet"
  type="custom"
  [title]="selectedUwItem?.description_2">
  @for (condition of selectedUwItem?.conditions; track condition; let last = $last) {
    <p>{{ condition.uw_description }}</p>
    @if (!last) {
      <hr class="hr--xs-md hr--bdr" />
    }
  }
</app-sidesheet>
